import { render, staticRenderFns } from "./recolumn-edit.vue?vue&type=template&id=9fd92d22&scoped=true"
import script from "./recolumn-edit.vue?vue&type=script&lang=js"
export * from "./recolumn-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd92d22",
  null
  
)

export default component.exports